import { render, staticRenderFns } from "./ParticipatingProductGroups.vue?vue&type=template&id=ef30e2e4&scoped=true"
import script from "./ParticipatingProductGroups.vue?vue&type=script&lang=js"
export * from "./ParticipatingProductGroups.vue?vue&type=script&lang=js"
import style0 from "./ParticipatingProductGroups.vue?vue&type=style&index=0&id=ef30e2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef30e2e4",
  null
  
)

export default component.exports